import CheckboxGroup, {
  CheckboxGroupProps,
} from "common/components/CheckboxGroup/CheckboxGroup";
import CircleCheckboxGroup from "common/components/CheckboxGroup/CircleCheckboxGroup";
import useDictionaries from "features/dictionaries/useDictionaries";

export interface BoatCheckboxSelectorProps
  extends Omit<CheckboxGroupProps, "options"> {
  compact?: boolean;
}

export default function BoatCheckboxSelector({
  compact,
  sx,
  ...props
}: BoatCheckboxSelectorProps) {
  const { dictionaries } = useDictionaries();
  const Comp = compact ? CircleCheckboxGroup : CheckboxGroup;
  return (
    <Comp
      options={dictionaries.boats?.map(b => ({
        ...b,
        _htmlTitle: compact ? b.label : null,
        label: compact ? b.label.substring(0, 1) : b.label,
      }))}
      sx={{
        //minWidth: 0,
        flex: 1,
        flexWrap: "wrap",
        minWidth: {
          xs: "80px",
          sm: "100px",
          md: "150px",
          lg: "200px",
        },
        ...sx,
      }}
      {...props}
    />
  );
}
